var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormEpisodes.jinja');
require('./SubmissionFormEpisodes.less');

var SubmissionFormEpisodesItem = require('submissions/components/SubmissionForm/SubmissionFormEpisodesItem');
var SubmissionFormEpisodesItemTemplate = require('submissions/components/SubmissionForm/SubmissionFormEpisodesItemRuntime.jinja');


var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'click .SubmissionFormEpisodes-add': 'onAddClick'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'triggerChange');

        var self = this;

        this.$('.SubmissionFormEpisodesItem').each(function () {
            var itemInstance = new SubmissionFormEpisodesItem({
                el: this
            });

            self.listenTo(itemInstance, 'delete', self.triggerChange);
            self.listenTo(itemInstance, 'change', self.triggerChange);

            $(this).data('instance', itemInstance);
        });

        this.triggerChange();

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {

        this.$('.SubmissionFormEpisodesItem').each(function () {
            var itemInstance = $(this).data('instance');

            itemInstance.deactivate();
        });

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    checkFooterVisibility: function () {
        var count = this.$('.SubmissionFormEpisodesItem').length;

        this.$('.SubmissionFormEpisodes-footer').toggleClass('SubmissionFormEpisodes-footer--hidden', count >= 3);
    },


    onAddClick: function () {
        var $template = $(SubmissionFormEpisodesItemTemplate.render({
            data: {},
            isRequired: false
        }));

        this.$('.SubmissionFormEpisodes-wrapper').append($template);

        var itemInstance = new SubmissionFormEpisodesItem({
            el: $template[0]
        });

        $template.data('instance', itemInstance);

        this.listenTo(itemInstance, 'delete', this.triggerChange);
        this.listenTo(itemInstance, 'change', this.triggerChange);

        this.triggerChange();
    },


    triggerChange: function () {
        var episodes = [];

        this.$('.SubmissionFormEpisodesItem').each(function () {
            var itemInstance = $(this).data('instance');

            episodes.push(itemInstance.getData());
        });

        app.data.episodes = episodes;

        app.vent.trigger('submissions-episodes-changed', episodes);

        this.checkFooterVisibility();
    },


    checkRequired: function () {
        var noErrors = true;

        this.$('.SubmissionFormEpisodesItem').each(function (ind) {
            var itemInstance = $(this).data('instance');
            noErrors = noErrors && itemInstance.checkRequired();
        });

        return noErrors;
    },


    getFormData: function () {
        var episodes = [];

        this.$('.SubmissionFormEpisodesItem').each(function (ind) {
            var itemInstance = $(this).data('instance');
            var data = itemInstance.getData();
            data.order = ind;

            episodes.push(data);
        });

        return {
            episodes: episodes
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodes.js
// module id = 115
// module chunks = 0